/**
 * @generated SignedSource<<2da4ac86d87e66a0b4fdccea06f4a1d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteAccessType = "CHANNEL" | "EVENT" | "INTRINSIC" | "SINGLE_NOTE" | "STREAM_SHARE";
import { FragmentRefs } from "relay-runtime";
export type ShareMeetingModal_sharedWith$data = {
  readonly noteuserSet: ReadonlyArray<{
    readonly accessType: ReadonlyArray<NoteAccessType>;
    readonly id: string;
    readonly user: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isConfigured: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
    };
  }>;
  readonly " $fragmentType": "ShareMeetingModal_sharedWith";
};
export type ShareMeetingModal_sharedWith$key = {
  readonly " $data"?: ShareMeetingModal_sharedWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_sharedWith">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareMeetingModal_sharedWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConfigured",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "2c807471c17a56e46dc254d86d9a1648";

export default node;
